import { Component } from '@angular/core';
import { ItemsListContentListViewComponent } from '../content-list-view/content-list-view.component';

@Component({
    selector: 'fi-items-list-content-list-view-with-children',
    templateUrl: './content-list-view-with-children.component.html',
    styleUrls: ['./content-list-view-with-children.component.scss'],
    standalone: false,
})
export class ItemsListContentListViewWithChildrenComponent extends ItemsListContentListViewComponent {}
